export default __webpack_public_path__ + "static/media/calendarSmall.ea023886.svg";